module.exports = __webpack_public_path__ + "resources/img/img_jp_popup_marketing.f3684a23ec06b488bba89ffe4a81ffb0.png";